var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "grill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5, 0.5)",
    fill: "none",
    stroke: "currentColor",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3,
    strokeLinecap: "round",
    d: " M49.532,4.437c2.54-2.54,5.925-1.464,8.677,1.287c2.752,2.752,3.981,5.983,1.287,8.677c-3.061,3.061-10.659,4.12-12.372,2.407 S46.471,7.498,49.532,4.437z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 3,
    strokeLinecap: "round",
    x1: 13.744,
    y1: 50.22,
    x2: 4,
    y2: 60,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 3,
    strokeLinecap: "round",
    x1: 47.14,
    y1: 16.824,
    x2: 39.078,
    y2: 24.886,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    strokeWidth: 3,
    strokeLinecap: "round",
    points: "23.488,20.988 44.925,42.425 37.13,50.22 13.744,26.835 21.539,19.039 23.488,20.988 ",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 3,
    strokeLinecap: "round",
    cx: 19.59,
    cy: 44.374,
    r: 8.268,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    strokeWidth: 3,
    strokeLinecap: "round",
    points: "27.386,24.886 33.232,19.039 44.925,30.732 39.078,36.579 ",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrill);
export default __webpack_public_path__ + "static/media/grill.5fb5446ec57730d434842ffe55571ec3.svg";
export { ForwardRef as ReactComponent };